export const removeWrappingPTags = (htmlString: string | undefined): string => {
  if (!htmlString) {
    return ""
  }
  const regex = /^<p>(.*?)<\/p>$/is
  const match = htmlString.match(regex)
  if (match && match[1]) {
    return match[1]
  }
  return htmlString
}
